
import { Vue } from "vue-class-component";

export default class Clock extends Vue {}
